export enum GraphQLOperationType {
  QUERY = 'query',
  MUTATION = 'mutation',
  // SUSBCRIPTION = 'subscription'
}
